import React from 'react';

import { LinkInNewPage,LinkOutSVG } from '../../../../../shared';

export function BannerDescription({ promoLink } = {}) {
  const accentColor = '#73233c';

  return <div className='sertificat__text'>
    <div>
      <p className='sertificat__text__paragraph'>
        Фільми-події німецького кінематографу – в одному з найстаріших українських фестивалів <span style={{ color: accentColor, fontWeight: '700' }}>«Нове німецьке кіно»</span>. 
      </p>
      <p className='sertificat__text__paragraph'>
        Цьогорічна програма поєднує володаря Золотого Ведмедя Берлінале–2026, нову роль Сандри Гюллер, 
        останню роботу режисера <span style={{ fontWeight: '500' }}>«Ґуд бай, Леніне!»</span>, 
        а також масштабний частково знятий у Києві кіноперформанс <span style={{ fontWeight: '500' }}>від автора «Маніфесто» за участі Кейт Бланшетт</span>.
      </p>

{/* 
      <p className='sertificat__text__paragraph'>
        Фестиваль проводять
        <span > </span>
        <LinkInNewPage 
          text="Goethe-Institut в Україні" 
          href="https://www.goethe.de/ins/ua/uk/" 
        /> 
        <span > </span>
        
        спільно з компанією
        <span > </span>
        <LinkInNewPage 
          text="«Артхаус Трафік»" 
          href="https://arthousetraffic.com/" 
        />
        <span > </span>

        за підтримки генерального партнера
        <span > </span>
        <LinkInNewPage 
          text="German Films" 
          href="https://www.german-films.de/" 
        />
        <span > </span>

        та офіційного партнера
        <span > </span>
        <LinkInNewPage 
          text="ProCredit Bank" 
          href="https://www.procreditbank.com.ua/" 
        />        
        .
      </p> */}



      <p className='sertificat__text__paragraph'>
        Фестиваль проводять<span > </span>
        <LinkInNewPage 
          text="Goethe-Institut в Україні" 
          href="https://www.goethe.de/ins/ua/uk/" 
        />
      </p>

      <p className='sertificat__text__paragraph'>
        Спільно з компанією<span > </span>
        <LinkInNewPage 
          text="«Артхаус Трафік»" 
          href="https://arthousetraffic.com/" 
        />
      </p>

      <p className='sertificat__text__paragraph'>
        За підтримки генерального партнера<span > </span>
        <LinkInNewPage 
          text="German Films" 
          href="https://www.german-films.de/" 
        />
      </p>

      <p className='sertificat__text__paragraph'>
        Та офіційного партнера<span > </span>
        <LinkInNewPage 
          text="ProCredit Bank" 
          href="https://www.procreditbank.com.ua/" 
        />  
      </p>
      
      <p style={{ paddingTop: '8px' }}></p>
      

      <p className='sertificat__text__paragraph'>
        <a target="_self" href={ promoLink } style={{
          color: accentColor,
          fontWeight: '700',
          display: 'flex',
          alignItems: 'center'
        }}>Квитки вже у продажу!<LinkOutSVG color={accentColor} /></a>
      </p>

    </div>
  </div >
}


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/NewGermanyCinema26/impl/BannerDescription/BannerDescription.jsx